import React, { useState } from "react";
import { Grid, Typography } from "@mui/material";
import {
  ICredentialsSouthpostErrors,
  ICredentialsSouthpostPayload,
} from "../../interfaces/configuration";
import { IValidation } from "../../interfaces/form";
import { ICredentialsModal } from "../../interfaces/modal";
import { ERRORS_MESSAGES } from "../../utils/constants";
import { validateInputs } from "../../utils/inputValidations";
import ModalBase from "./ModalBase";
import CredentialsSouthpost from "../forms/CredentialsSouthpost";
import ConfirmChangesCredentials from "../configuration/ConfirmChangesCredentials";
import GenericForm from "../GenericForm";
import GenericAlert from "../GenericAlert";

const { tokenRequired, branchCodeRequired } = ERRORS_MESSAGES;

const formValidations: IValidation[] = [
  {
    id: "api_token",
    type: "required",
    message: tokenRequired,
  },
  {
    id: "branch_code",
    type: "required",
    message: branchCodeRequired,
  },
];

const CredentialsSouthpostModal = ({
  open,
  onClose,
  carrier,
  handleChangeOfConfig,
}: ICredentialsModal) => {
  const credentials = (carrier.credentials ||
    {}) as ICredentialsSouthpostPayload;

  const [values, setValues] = useState(credentials);
  const [errors, setErrors] = useState({} as ICredentialsSouthpostErrors);

  const handleSubmit = () => {
    const inputErrors = validateInputs(values, formValidations);
    setErrors(inputErrors);
    if (Object.keys(inputErrors).length === 0) {
      handleChangeOfConfig({
        _id: carrier._id,
        name: carrier.name,
        disabled: carrier.disabled,
        credentials: values,
      });
      onClose();
    }
  };

  return (
    <ModalBase open={open} handleClose={onClose} maxWidth="md">
      <Grid container>
        <Typography className="f-s-18 m-b-10">
          Ingresa los datos de tu contrato con Southpost
        </Typography>

        <Grid item xs={12} className="m-b-20">
          <GenericAlert
            alert={{
              showAlert: true,
              message:
                `¡Importante!
                Asegúrate de que el código de sucursal de origen que declaraste en el contrato coincida exactamente
                con la dirección del warehouse que tienes registrado en el sistema.
                Si no coincide, no podremos gestionar el retiro y/o cotización de los productos correctamente.
                ¡Verifica que todo esté en orden para evitar inconvenientes!` ,
              typeOfAlert: "info",
            }}
          />
        </Grid>

        <GenericForm onSubmit={handleSubmit}>
          <CredentialsSouthpost
            values={values}
            setValues={setValues}
            errors={errors}
          />
        </GenericForm>

        <ConfirmChangesCredentials
          onClose={onClose}
          handleSubmit={handleSubmit}
        />
      </Grid>
    </ModalBase>
  );
};

export default CredentialsSouthpostModal;
